import { connect } from 'react-redux';
import { updateSectionPermissions } from '../actions';
import SectionsPageStep from '../components/SectionsPageStep';
import { getSectionsPageStep } from '../selectors';

const mapStateToProps = state => getSectionsPageStep(state);

const mapDispatchToProps = dispatch => {
    return {
        onToggleAccessType: (sectionNames, accessType) => dispatch(updateSectionPermissions(sectionNames, accessType)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(SectionsPageStep);
